import React from 'react'
import styled from 'styled-components'

interface Props {
  label?: string
  unit?: string
}

const Label = styled.div`
  display: flex;
  justify-content: space-between;
  gap: 6px;
  align-self: stretch;
`

const LabelBody = styled.div`
  display: flex;
  align-items: center;
  gap: 6px;
`

const LabelLine = styled.div`
  width: 4px;
  height: 100%;
  border-radius: 99px;
  background: #2f3c5e;
`

const LabelName = styled.div`
  font-family: SUIT;
  font-size: 16px;
  font-weight: 700;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
`

const UnitTextBox = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
`

const UnitText = styled.div`
  color: var(--gray80, #4d4d4d);
  font-family: SUIT;
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
`

const LabelUnit = (props: Props) => {
  const { label, unit } = props

  return (
    <Label>
      <LabelBody>
        <LabelLine />
        <LabelName>{label || '라벨'}</LabelName>
      </LabelBody>
      <UnitTextBox>{unit ? <UnitText>{unit}</UnitText> : <></>}</UnitTextBox>
    </Label>
  )
}

export default LabelUnit
